import { FC, useContext, useEffect, useMemo } from "react"
import { EnterpriseComplianceDashboardContext } from "../contexts/EcdContext";
import { filterToTimeFrame } from "../utility";
import { DashboardTile } from "@app/shared/qes-standards";
import EnterpriseComplianceDashboardTimeFrame from "../components/EcdTimeFrame";
import { EcdTilesEnum, TimeFrameOptions } from "../interfaces";
import { EnterpriseComplianceFiltersContext } from "../contexts/EcdFiltersContext";
import { EcdColorsContext } from "../contexts/EcdColorsContext";
import GapsByAgeChart from "../components/GapsByAgeChart";

const GapsByAge: FC = () => {
    const filtersContext = useContext(EnterpriseComplianceFiltersContext);
    const dashboardContext = useContext(EnterpriseComplianceDashboardContext);
    const colorsContext = useContext(EcdColorsContext);

    const slicedGapsByAgeData = useMemo(() => {
        return filterToTimeFrame(dashboardContext.gapsByAgeData, filtersContext.gapsByAgeTimeFrame);
    }, [dashboardContext.gapsByAgeData, filtersContext.gapsByAgeTimeFrame]);

    useEffect(() => {
        dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.GapsByAge, true);
    }, []);

    useEffect(() => {
        if (slicedGapsByAgeData && dashboardContext.adequacyBreakdownData) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.GapsByAge, false);
        }
    }, [slicedGapsByAgeData, dashboardContext.adequacyBreakdownData]);

    useEffect(() => {
        if (!!filtersContext.apiReadyFilters) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.GapsByAge, true);
        }
    }, [filtersContext.apiReadyFilters]);

    return (
        <DashboardTile
            headerElement={
                <EnterpriseComplianceDashboardTimeFrame
                    disabled={dashboardContext.isTileLoadingMap.get(EcdTilesEnum.GapsByAge)}
                    onChange={(value: string) => filtersContext.setGapsByAgeTimeFrame(value as TimeFrameOptions)}
                    selectedKey={filtersContext.gapsByAgeTimeFrame}
                    tileKey="gaps-by-age"
                />
            }
            loading={
                filtersContext.isDashboardLoading ||
                dashboardContext.isTileLoadingMap.get(EcdTilesEnum.GapsByAge) ||
                dashboardContext.isTileLoadingMap.get(EcdTilesEnum.AdequacyBreakdown)}
            title="Gaps by Age"
            widthClass="col-lg-12 col-xl-5"
        >
          <GapsByAgeChart
            gapsByAgeData={slicedGapsByAgeData}
            adequacyBreakdownData={dashboardContext.adequacyBreakdownData}
            barHoverBackground={colorsContext.barHoverBackground }
            gapsArray={colorsContext.gapsArray}
            isExport={false}
          />
        </DashboardTile>
    )
};

export default GapsByAge;
